module.exports = __webpack_public_path__ + "static/media/warning_icon.55066827.svg";